import React from 'react';
import { Button, Carousel, Checkbox, DatePicker, Form, Input, Radio, Select, Row, Col} from 'antd';

import config from '../config/config';

const {fields } = config.purchase;

const {Option} = Select;

const ParticipantForm = (props) => (
  <div key={`${props.name}_${props.idx}`}>
    {/*
    <h3>参加者 {props.idx}</h3>
    <Field {...fields.gender} name={`${props.name}_gender[${props.idx}]`}>
      <Radio.Group>
        {fields.gender.items.map(item => (
          <Radio.Button value={item.key} key={item.key}>{item.label}</Radio.Button>
        ))}
      </Radio.Group>
    </Field>
    <Row gutter={16}>
      <Col xs={24} sm={12}>
        <Field {...fields.first_name} name={`${props.name}_first_name[${props.idx}]`}>
          <Input/>
        </Field>
      </Col>
      <Col xs={24} sm={12}>
        <Field {...fields.last_name} name={`${props.name}_last_name[${props.idx}]`}>
          <Input/>
        </Field>
      </Col>
    </Row>
    */}
  </div>
);

export default ParticipantForm;



// WEBPACK FOOTER //
// ./src/pages/purchase/components/ParticipantForm.js